import styled from 'styled-components';

export const OverlayWrapper = styled.div<{ $isOutside: boolean }>`
  box-sizing: border-box;

  max-width: 30rem;

  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2)};
  box-shadow: ${({ theme }) => theme.shadowBox.menu};
  opacity: ${({ $isOutside }) => ($isOutside ? 0 : 1)};
  transition: opacity 200ms;
  overflow: hidden;
  pointer-events: none;
`;
